const options = {
  5: "bg-neutral-800/5",
  10: "bg-neutral-800/10",
  25: "bg-neutral-800/25",
  50: "bg-neutral-800/50",
  75: "bg-neutral-800/75",
  90: "bg-neutral-800/90",
  100: "bg-neutral-800",
};

const from = {
  5: "from-neutral-800/5",
  10: "from-neutral-800/10",
  25: "from-neutral-800/25",
  50: "from-neutral-800/50",
  75: "from-neutral-800/75",
  90: "from-neutral-800/90",
  100: "from-neutral-800",
};

export default function getBackgroundNeutral800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
